import {
    NavigationBar,
    IconChevronLeftRegular,
    Text2,
    ThemeVariant,
    Text3,
    Text6,
    Tag,
    ButtonSecondary,
    BoxedRow,
    Text1,
    ButtonPrimary,
    IconCheckedRegular,
    IconTimeRegular,
    IconCancelRegular,
    IconFolderRegular,
    IconInformationRegular,
    Spinner,
    Callout,
    IconInformationUserRegular,
    ButtonLink,
    Inline,
    skinVars,
    useDialog,
    useWindowSize,
} from '@telefonica/mistica';
import { AxiosError, AxiosResponse } from 'axios';
import { t } from 'i18next';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import StepperBullet from '../../../../components/StepperBullet';
import {
    EProblemFeedback,
    EProblemFeedbackType,
    EProblemTypeEvent,
    IProblemEvent,
    IProblemIssue,
    IProblemShippingOrderTask,
    IProblemTroubleTicket,
    IProblemTroubleTicketTask,
    IProblemWorkTask,
    IStepperTimeLineIssue,
    IWorkOrder,
    IIndexGeneric,
    IShippingOrderZeleris,
} from '../../../../models/Problems.interfaces';
import {
    cancelProblemById,
    getEventsProblemById,
    getListTasksProblemsById,
    getProblemById,
    getProblemsWorkTasks,
    getShippingOrderTask,
    getTroubleticketById,
    getTroubleticketTask,
    getWorkById,
    resumeProblemById,
    getShippingOrderZelerisById,
} from '../../../../services/ProblemService';
import { getFormatDate } from '../../../../utils/dataTransformation/dateConversions';
import navigateParams from '../../../../utils/navigation/navigateParams';
import { literalsFeedback } from '../../utils.chat';
import './index.scss';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';
import { getEnv } from '../../../../utils/dataTransformation/environments';

type IBulletTask = IProblemWorkTask & IProblemShippingOrderTask & IProblemTroubleTicketTask & IStepperTimeLineIssue;

export const IncidentDetail: React.FC = () => {
    const navigate = useNavigate();
    const buttonsRef = useRef<HTMLDivElement>(null);
    const [visible, setVisible] = useState(true);
    const { trackingScreenView } = new TrackingEvents();
    const contactWhatsapp = getEnv('VITE_WEBVIEW_NUMBER_CONTACT_WHATSAPP') as string;
    const TIME_CANCEL_PROBLEM = 3000;
    const { problemId } = useParams();
    const [problemCode, setProblemCode] = useState<string>();
    const orderId = useRef<string>();
    const [problem, setProblem] = useState<string>();
    const [problemCreateDate, setProblemCreateDate] = useState<string>();
    const [problemEndedDate, setProblemEndedDate] = useState<string>();
    const [problemEvents, setProblemEvents] = useState<IStepperTimeLineIssue[]>([]);
    const [phase, setPhase] = useState<string>();
    const [situation, setSituation] = useState<string>();
    const [loading, setLoading] = useState<boolean>(true);
    const tasks = useRef<IBulletTask[]>([]);
    const { dialog } = useDialog();
    type ThrottledFunction = (...args: any[]) => void;
    const size = useWindowSize();

    const translateTask = (task: IBulletTask): IStepperTimeLineIssue => {
        const title = '';
        const date = task?.date || task?.creationDate || task?.itemTask?.creationDate || '';
        const descriptionType = task?.descriptionType || task?.typeCause || task?.type || '';
        const customerComments = task?.customerComments || '';

        return {
            date,
            title,
            descriptionType,
            customerComments,
        };
    };

    const throttle = (func: ThrottledFunction, limit: number): ThrottledFunction => {
        let inThrottle: boolean;
        return function (this: any, ...args: any[]) {
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => (inThrottle = false), limit);
            }
        };
    };

    const handleGetDetailShipping = async (shippingOrderId: string) => {
        return new Promise((resolve) => {
            const isLogisticShipping = tasks.current.some(
                (task) =>
                    task?.descriptionType === 'Envío solicitud a Logística' ||
                    task?.type === 'Envío solicitud a Logística',
            );
            getShippingOrderZelerisById({
                shippingOrderId,
                orderId: orderId.current!,
            })
                .then((response: AxiosResponse<IShippingOrderZeleris>) => {
                    const { data } = response;
                    const isOrderZeleris = data?.url?.length;

                    if (isLogisticShipping && isOrderZeleris) {
                        resolve({
                            date: data.situationDate,
                            descriptionType: 'Dispositivo enviado',
                            title: '',
                            customerComments: data.url,
                        });
                    } else {
                        resolve(null);
                    }
                })
                .catch((error: AxiosError) => {
                    console.error(error);
                    resolve(null);
                });
        });
    };

    const handleGetDetailWorkOrder = async (workOrderId: string) => {
        return new Promise((resolve) => {
            getWorkById({ workOrderId })
                .then(({ data }: AxiosResponse<IWorkOrder>) => {
                    const { appointments, creationDate } = data;
                    const isDateTechnician = appointments.length;
                    const isWorkOrder = tasks.current.some(
                        (task) =>
                            task?.descriptionType === 'Envío solicitud a Fuerza de Trabajo' ||
                            task?.type === 'Envío solicitud a Fuerza de Trabajo',
                    );

                    if (isDateTechnician && isWorkOrder) {
                        const _dates = {
                            day: getFormatDate(appointments[0].startInterval, 'DD/MM'),
                            initDate: getFormatDate(appointments[0].startInterval, '00:00'),
                            finishDate: getFormatDate(appointments[0].endInterval, '00:00'),
                        };
                        resolve({
                            date: creationDate,
                            descriptionType: 'Visita técnica concertada',
                            title: 'Visita técnica concertada',
                            customerComments: `${t('supportDateTechnical')} ${_dates.day} ${t('of')} ${
                                _dates.initDate
                            } ${t('to')} ${_dates.finishDate}.`,
                        });
                    } else {
                        resolve(null);
                    }
                })
                .catch((error: AxiosError) => {
                    resolve(null);
                });
        });
    };

    const getListTasks = async (
        workOrders: IIndexGeneric[],
        shippingOrders: IIndexGeneric[],
        troubleTicketId: string,
    ): Promise<IBulletTask[]> => {
        let _promises: Promise<AxiosResponse>[] = [];
        let _tasksList: IBulletTask[] = [];

        if (troubleTicketId) _promises.push(getTroubleticketTask({ troubleTicketId }));

        if (workOrders?.length) {
            workOrders.forEach((item: IIndexGeneric) => {
                if (item?.id) _promises.push(getProblemsWorkTasks({ workOrderId: item.id }));
            });
        }

        if (shippingOrders?.length) {
            shippingOrders.forEach((item: IIndexGeneric) => {
                if (item?.id) _promises.push(getShippingOrderTask({ shippingOrderId: item.id }));
            });
        }
        const _tasks = await Promise.allSettled([getListTasksProblemsById({ problemId: problemId! }), ..._promises]);

        return new Promise((resolve) => {
            _tasks.forEach((item: PromiseSettledResult<AxiosResponse>) => {
                const { status } = item;
                if (status === 'fulfilled' && item?.value?.data?.length) {
                    _tasksList = [..._tasksList, item.value.data];
                }
            });
            resolve(_tasksList.flat());
        });
    };

    const orderTasks = (tasks: IBulletTask[]): IStepperTimeLineIssue[] =>
        tasks!
            .filter((task: IBulletTask) => task)
            .map((item: any) => translateTask(item as IBulletTask))
            .sort((a: IStepperTimeLineIssue, b: IStepperTimeLineIssue) => +new Date(b.date) - +new Date(a.date));

    const getTasks = async (troubleTicketId: string) => {
        await getTroubleticketById({ troubleTicketId })
            .then(async (response: AxiosResponse) => {
                const { data }: { data: IProblemTroubleTicket } = response;
                const { workOrders, shippingOrders } = data;

                setProblemCode(data.code);

                getListTasks(workOrders, shippingOrders, troubleTicketId)
                    .then(async (response: IBulletTask[]) => {
                        tasks.current = response;

                        const isWorkOrder = workOrders?.some((work: IIndexGeneric) => work?.id);
                        const isShippingOrder = shippingOrders?.some((shipping: IIndexGeneric) => shipping?.id);

                        if (isWorkOrder) {
                            const _data = await handleGetDetailWorkOrder(workOrders[0].id);

                            if (typeof _data === 'object') {
                                const _tasks = orderTasks([...response, _data as IBulletTask]);
                                setProblemEvents(_tasks!);
                            }
                        }

                        if (isShippingOrder) {
                            const _data = await handleGetDetailShipping(shippingOrders[0].id);

                            if (typeof _data === 'object') {
                                const _tasks = orderTasks([...response, _data as IBulletTask]);
                                setProblemEvents(_tasks);
                            }
                        }

                        if (!isWorkOrder && !isShippingOrder) {
                            const _tasks = orderTasks(response);
                            setProblemEvents(_tasks);
                        }

                        setLoading(false);
                    })
                    .catch((error: AxiosError) => {
                        console.error(error, 'entro');
                        setLoading(false);
                    });
            })
            .catch((error: AxiosError) => {
                console.error(error, 'entro');
                setLoading(false);
                const queryParams = {
                    phase: EProblemFeedbackType.ERROR,
                    error: EProblemFeedback.SERVICE,
                    ...literalsFeedback(EProblemFeedback.SERVICE),
                };
                if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                    navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                }
            });
    };

    const [calloutIssuePending, setCalloutIssuePending] = useState<boolean>(false);
    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView(window.location.pathname.split('/').slice(0, 4).join('/'));
        }

        getProblemById({ problemId: problemId! })
            .then((response: AxiosResponse) => {
                const { data }: { data: IProblemIssue } = response;
                setProblem(data.motive.description);
                setProblemCreateDate(data.createdAt);
                setProblemEndedDate(data.endedAt);
                setPhase(data.phase);
                setSituation(data.situation);
                orderId.current = data.code;

                handleGetEventsIssue()
                    .then((events) => {
                        const isCalloutCalled1551 = events.some(
                            (event: IProblemEvent) => event.type === EProblemTypeEvent.DIAGNOSIS_ENDED_TESTING_PENDING,
                        );

                        if (isCalloutCalled1551) setCalloutIssuePending(isCalloutCalled1551);

                        if (data?.troubleTicket?.id) {
                            getTasks(data?.troubleTicket?.id);
                        } else {
                            setProblemCode(data.code);
                            getListTasksProblemsById({ problemId: problemId! })
                                .then((tasks: AxiosResponse) => {
                                    const { data } = tasks;
                                    const orderTasks = data.sort(
                                        (a: { [key: string]: string }, b: { [key: string]: string }) => {
                                            return +new Date(b.date) - +new Date(a.date);
                                        },
                                    );
                                    setProblemEvents(orderTasks);
                                    setLoading(false);
                                })
                                .catch((error: AxiosError) => {
                                    console.error(error);
                                    setLoading(false);
                                    const queryParams = {
                                        phase: EProblemFeedbackType.ERROR,
                                        error: EProblemFeedback.SERVICE,
                                        ...literalsFeedback(EProblemFeedback.SERVICE),
                                    };
                                    if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                                        navigate(
                                            `/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`,
                                        );
                                    }
                                });
                        }
                    })
                    .catch(() => {
                        const queryParams = {
                            phase: EProblemFeedbackType.ERROR,
                            error: EProblemFeedback.SERVICE,
                            ...literalsFeedback(EProblemFeedback.SERVICE),
                        };
                        if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                            navigate(
                                `/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`,
                            );
                        }
                    });
            })
            .catch((error: AxiosError) => {
                setLoading(false);
                const queryParams = {
                    phase: EProblemFeedbackType.ERROR,
                    error: EProblemFeedback.SERVICE,
                    ...literalsFeedback(EProblemFeedback.SERVICE),
                };
                if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                    navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                }
            });

        const handleScroll = throttle(() => {
            if (size.width <= 768) {
                const heightCard = buttonsRef.current?.scrollHeight! - buttonsRef.current?.clientHeight!;

                setVisible(heightCard + 1 > window.scrollY);
            }
        }, 15);
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const sendToNative = (
        url: string,
        type: string,
        title: string,
        description?: string,
        code?: string,
        err?: any,
        titleFeedback?: string,
        externalLink?: boolean,
    ) => {
        const queryParams = {
            state: description,
            errorCode: err ? err.id : '',
            title: t('supportInfoFeedbackCanceledIncidentTitle'),
            subtitle: t('supportInfoFeedbackCanceledIncidentDescription') + `Nº: ${code}`,
        };
        const feedbackData = {
            stateFeedback: description,
            titleFeedback: titleFeedback,
            code: code,
        };
        if (navigateParams(type, url, queryParams)) {
            if (type === 'feedback-info') {
                navigate(url, { state: feedbackData });
            } else if (type === 'modeFlow-backgroundBlue') {
                navigate(url);
            } else if (type === 'modeExternal') {
                if (externalLink) {
                    window.open(url, '_blank');
                } else {
                    window.location.href = url;
                }
            }
        }
    };

    const setTypeTagPhase = (phase: any, situation: any) => {
        if (phase === 'ABI') {
            return (
                <Tag Icon={IconTimeRegular} type='warning'>
                    {t('ordersTagInProgress')}
                </Tag>
            );
        } else if (phase === 'CUR') {
            return situation === 'Pendiente de diagnóstico de cliente' ? (
                <Tag Icon={IconInformationRegular} type='error'>
                    {t('ordersTagPending')}
                </Tag>
            ) : (
                <Tag Icon={IconTimeRegular} type='warning'>
                    {t('ordersTagInProgress')}
                </Tag>
            );
        } else if (phase === 'CON') {
            return (
                <Tag Icon={IconCheckedRegular} type='success'>
                    {t('supportTagIncidentsResolved')}
                </Tag>
            );
        } else if (phase === 'PEN') {
            return (
                <Tag Icon={IconFolderRegular} type='active'>
                    {t('supportTagIncidentsFinished')}
                </Tag>
            );
        } else if (phase === 'CER') {
            return situation === 'Cancelado' || situation === 'Anulado' ? (
                <Tag Icon={IconCancelRegular} type='inactive'>
                    {t('supportTagIncidentsCancelled')}
                </Tag>
            ) : (
                <Tag Icon={IconCancelRegular} type='inactive'>
                    {t('supportTagIncidentsClosed')}
                </Tag>
            );
        }
        return null;
    };

    const CancelIncidence = () => {
        setLoading(true);
        cancelProblemById({ problemId: problemId! })
            .then((response: AxiosResponse) => {
                setTimeout(() => {
                    setLoading(false);
                    sendToNative(
                        '/support/incidents-feedback',
                        'feedback-info',
                        '',
                        'INFO',
                        `${problemCode}`,
                        '',
                        t('supportInfoFeedbackCanceledIncidentTitle'),
                    );
                }, TIME_CANCEL_PROBLEM);
            })
            .catch((error: AxiosError) => {
                setLoading(false);
                const queryParams = {
                    phase: EProblemFeedbackType.ERROR,
                    error: EProblemFeedback.SERVICE,
                    ...literalsFeedback(EProblemFeedback.SERVICE),
                };
                if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                    navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                }
                console.error(error);
            });
    };

    const redirectChat = () => {
        setLoading(false);
        const queryParams = {
            id: problemId,
            action: EProblemTypeEvent.DIAGNOSIS_RESUMED,
            code: problemCode,
        };
        if (
            navigateParams(
                'modeFlow-backgroundBlue',
                '/support/solve-incident',
                queryParams,
                {},
                t('supportContentRowSolveIncidentTitle'),
            )
        ) {
            navigate(`/support/solve-incident?id=${queryParams.id}&action=${queryParams.action}&code=${problemCode}`);
        }
    };

    const handleResumeIncidence = () => {
        resumeProblemById({ problemId: problemId! })
            .then(() => {
                setLoading(false);
                redirectChat();
            })
            .catch((error: AxiosError) => {
                console.error(error);
                setLoading(false);
                const queryParams = {
                    phase: EProblemFeedbackType.ERROR,
                    error: EProblemFeedback.SERVICE,
                    ...literalsFeedback(EProblemFeedback.SERVICE),
                };
                if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                    navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                }
            });
    };

    const handleGetEventsIssue = (): Promise<IProblemEvent[]> => {
        return new Promise((resolve) => {
            setLoading(true);
            getEventsProblemById({ problemId: problemId! })
                .then((response: AxiosResponse) => {
                    const { data }: { data: IProblemEvent[] } = response;

                    resolve(data);
                })
                .catch((error: AxiosError) => {
                    console.error(error);
                    setLoading(false);
                    const queryParams = {
                        phase: EProblemFeedbackType.ERROR,
                        error: EProblemFeedback.SERVICE,
                        ...literalsFeedback(EProblemFeedback.SERVICE),
                    };
                    if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                        navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                    }
                });
        });
    };

    const resumeIncidence = () => {
        handleGetEventsIssue()
            .then((events) => {
                const responses = [
                    EProblemTypeEvent.DIAGNOSIS_ENDED,
                    EProblemTypeEvent.DIAGNOSIS_ENDED_CANCELED,
                    EProblemTypeEvent.DIAGNOSIS_ENDED_TRANSFER_CHANNEL,
                    EProblemTypeEvent.DIAGNOSIS_ENDED_SHIPMENT_PENDING,
                    EProblemTypeEvent.DIAGNOSIS_ENDED_VALIDATION_PENDING,
                    EProblemTypeEvent.DIAGNOSIS_ENDED_CONTINUE_WITHOUT_INTERACTION,
                    EProblemTypeEvent.DIAGNOSIS_ENDED_TECHNICIAN_ASSIGNMENT_PENDING,
                    EProblemTypeEvent.DIAGNOSIS_ENDED_TESTING_PENDING,
                ];
                const isResume = events.some((event: IProblemEvent) => responses.includes(event.type));

                isResume ? handleResumeIncidence() : redirectChat();
            })
            .catch(() => {
                const queryParams = {
                    phase: EProblemFeedbackType.ERROR,
                    error: EProblemFeedback.SERVICE,
                    ...literalsFeedback(EProblemFeedback.SERVICE),
                };
                if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                    navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                }
            });
    };

    if (loading) {
        return (
            <div className='c-spinner'>
                <Spinner size={24} />
                <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
            </div>
        );
    }

    return (
        <div className='incidentDetail-page'>
            <div
                className='incidentDetail-page__header'
                style={{
                    background: skinVars.colors.background,
                    borderBottom: `1px solid ${skinVars.colors.divider}`,
                }}
            >
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='incidentDetail-page__header-navigationBar'>
                            <NavigationBar
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t('returnsupportIncidentDetail')}
                            />
                        </div>
                        <div className='incidentDetail-page__header-return'>
                            <div
                                className='incidentDetail-page__header-return-cursor'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <div className='incidentDetail-page__header-return-cursor-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.textPrimary} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.textPrimary}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='incidentDetail-page__header-breadcrumbs'>
                    <ThemeVariant>
                        <BreadCrumbsWrapper
                            title={t('returnsupportIncidentDetail')}
                            breadcrumbs={[
                                { title: t('breadcrumbsSupport'), url: '/support' },
                                { title: 'Tus incidencias', url: '/support/incidents' },
                            ]}
                        />
                    </ThemeVariant>
                </div>
                <div className='incidentDetail-page__header-animation'>
                    <div className='incidentDetail-page__header-animation-id'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {problemCode}
                        </Text3>
                    </div>
                    <div
                        className='incidentDetail-page__header-animation-phase'
                        style={{ paddingBottom: visible ? '0px' : '8px' }}
                    >
                        <ThemeVariant>{setTypeTagPhase(phase, situation)}</ThemeVariant>
                    </div>
                </div>
                <div className='incidentDetail-page__header-title'>
                    <div className='incidentDetail-page__header-title-name'>
                        <div className={`${visible ? 'incidentDetail-page__header-title-name-desktop' : 'hidden'}`}>
                            <Text6 color={skinVars.colors.textPrimary}>{problem}</Text6>
                            <div className='incidentDetail-page__header-title-name-desktop-date'>
                                <div className='incidentDetail-page__header-title-name-desktop-date-startDate'>
                                    <div className='incidentDetail-page__header-title-name-desktop-date-startDate-literal'>
                                        <Text2 regular color={skinVars.colors.textPrimary}>
                                            {t('supportIncidentsCreationDate')}
                                        </Text2>
                                    </div>
                                    <Text2 regular color={skinVars.colors.textSecondary}>
                                        {getFormatDate(new Date(problemCreateDate as any), 'DD/MM/YYYY')}
                                    </Text2>
                                </div>
                                {problemEndedDate && (
                                    <div className='incidentDetail-page__header-title-name-desktop-date-finishDate'>
                                        <div className='incidentDetail-page__header-title-name-desktop-date-finishDate-literal'>
                                            <Text2 regular color={skinVars.colors.textPrimary}>
                                                {t('supportIncidentsEndDate')}
                                            </Text2>
                                        </div>
                                        <Text2 regular color={skinVars.colors.textSecondary}>
                                            {getFormatDate(new Date(problemEndedDate as any), 'DD/MM/YYYY')}
                                        </Text2>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div
                            className={`incidentDetail-page__header-title-name-button ${
                                calloutIssuePending ? 'is-pending-client-callout' : ''
                            }`}
                            ref={buttonsRef}
                        >
                            {phase === 'CUR' && (
                                <ThemeVariant>
                                    <Inline
                                        className='incidentDetail-page__header-title-name-button-inline'
                                        space={16}
                                        fullWidth={true}
                                    >
                                        <ButtonPrimary
                                            className='incidentDetail-page__header-title-name-button-inline-buttons'
                                            onPress={() => {
                                                dialog({
                                                    className:
                                                        'incidentDetail-page__header-title-name-button-inline-confirm',
                                                    title: t('supportIncidentDetailModalCancelTitle'),
                                                    message: t('supportIncidentDetailModalCancelDescription'),
                                                    asset: (
                                                        <IconInformationUserRegular
                                                            size={64}
                                                            color={skinVars.colors.brand}
                                                        ></IconInformationUserRegular>
                                                    ),
                                                    acceptText: t('supportIncidentDetailBtnCancel'),
                                                    onAccept: () => CancelIncidence(),
                                                    onCancel() {},
                                                    cancelText: t('changesPasswordErrorFeedbackButton'),
                                                });
                                            }}
                                        >
                                            {t('supportIncidentDetailBtnCancel')}
                                        </ButtonPrimary>
                                        {calloutIssuePending && (
                                            <ButtonSecondary
                                                className='incidentDetail-page__header-title-name-button-inline-buttons'
                                                onPress={() => resumeIncidence()}
                                            >
                                                {t('supportIncidentDetailBtnReturn')}
                                            </ButtonSecondary>
                                        )}
                                    </Inline>
                                    {calloutIssuePending && (
                                        <Inline
                                            className='incidentDetail-page__header-title-name-button-inline'
                                            space={16}
                                        >
                                            <div className='incidentDetail-page__header-title-callout'>
                                                <Callout
                                                    asset={
                                                        <IconInformationUserRegular
                                                            size={24}
                                                            color={skinVars.colors.brand}
                                                        />
                                                    }
                                                    title={t('supportInfoFeedbackPendingIncidentTitle')}
                                                    description={t('supportIncidentDetailCalloutPendingDescription')}
                                                    buttonLink={
                                                        <div className='incidentDetail-page__header-desktop-button-buttonLink'>
                                                            <ButtonLink
                                                                onPress={() => {
                                                                    window.open(
                                                                        `https://wa.me/${contactWhatsapp}?text=Quiero%20continuar%20con%20las%20comprobaciones%20para%20resolver%20mi%20incidencia`,
                                                                        '_blank',
                                                                    );
                                                                }}
                                                            >
                                                                {t('buttonLinkCalloutIncidentPending')}
                                                            </ButtonLink>
                                                        </div>
                                                    }
                                                ></Callout>
                                            </div>
                                        </Inline>
                                    )}
                                </ThemeVariant>
                            )}
                        </div>
                    </div>
                    {phase === 'CON' && (
                        <div className='incidentDetail-page__header-title-callout'>
                            <Callout
                                asset={<IconInformationUserRegular size={24} color={skinVars.colors.brand} />}
                                title={t('supportIncidentDetailCalloutTitle')}
                                description={t('supportIncidentDetailCalloutDescription')}
                                buttonLink={
                                    <div className='incidentDetail-page__header-desktop-button-buttonLink'>
                                        <ButtonLink onPress={() => sendToNative('tel://1551', 'modeExternal', '')}>
                                            {t('contentModalHelpWithAccessBtnCard')}
                                        </ButtonLink>
                                    </div>
                                }
                            ></Callout>
                        </div>
                    )}
                </div>
            </div>
            <div className='incidentDetail-page__content'>
                <Text1 dataAttributes={{ title: 'title' }} medium color={skinVars.colors.textSecondary}>
                    {t('orderTrackingContentTracing')}
                </Text1>
                <BoxedRow
                    title=''
                    extra={
                        <div className='incidentDetail-page__content-boxedRow-extra'>
                            {<StepperBullet bullets={problemEvents} />}
                        </div>
                    }
                ></BoxedRow>
            </div>
        </div>
    );
};

export default IncidentDetail;
